import { Spinner } from '@orbita-ui/core';
import React, { ReactElement, useEffect } from 'react';
import { useKeycloak } from '../../auth/keycloak';

const PrivateRoute = ({ children }: { children: ReactElement }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized) {
      if (!keycloak.authenticated) {
        keycloak.login();
      }
    }
  }, [initialized]);

  if (!initialized || !keycloak.authenticated) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', margin: '10rem' }}>
        <Spinner />
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
